import Service from "../Service";

const resource = "accounting/";

export default {
    save(obj, requestID) {
        return Service.post(resource + "cvsave", obj, {
            params: { requestID: requestID },
        });
    },
    pagination(parameters, requestID) {
        return Service.post(resource + "cgpagination", parameters, {
            params: { requestID: requestID },
        });
    },
};
